class EnumUtils {
  static toShortString(value: { toString: () => string }): string {
    return value.toString().split(".").pop() || "";
  }

  static enumFromString<T extends Record<string, string>>(
    enumObj: T,
    value: string
  ): T[keyof T] | undefined {
    return (Object.values(enumObj) as Array<T[keyof T]>).find((enumValue) => enumValue === value);
  }
}

//   // Helper function to mimic Dart's enumFromString
//   function enumFromString<T>(enumObj: T, value: string): T[keyof T] {
//     const enumValues = Object.values(enumObj as any) as string[];
//     return enumValues.includes(value) ? (value as T[keyof T]) : (enumObj as any)["Error"];
//   }

enum SignAlgorithm {
  Error = "Error",
  ECDSA = "ECDSA",
  EDDSA = "EDDSA",
  P256 = "P256",
}

enum PolicyType {
  Error = "Error",
  Transaction = "Transaction",
  Groups = "Groups",
  Recovery = "Recovery",
  NoActive = "NoActive",
  Deposit = "Deposit",
}

enum BasicProcessPhase {
  NON_EXISTS = "NON_EXISTS",
  INITIATED = "INITIATED",
  IN_VALIDATION_PROCESS = "IN_VALIDATION_PROCESS",
  VALIDATED = "VALIDATED",
  EXECUTED = "EXECUTED",
  FAILED = "FAILED",
}

enum ActionRequestStateType {
  ToChange = "toChange",
  IsNew = "isNew",
  Deleted = "deleted",
  ToDelete = "toDelete",
}

enum UiActionStatus {
  All = "All",
  Initial = "Initial",
  Preparing = "Preparing",
  Failed = "Failed",
  VoteNeeded = "Vote_Needed",
  SentToSafe = "Sent_To_Safe",
  InProgress = "In_Progress",
  Accepted = "Accepted",
  Rejected = "Rejected",
  Completed = "Completed",
  Transferring = "Transferring",
  TimePending = "time_pending",
  Deposited = "Deposited",
}

enum ConditionStatus {
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  NON_RELEVANT = "NON_RELEVANT",
  DATA_MISSING = "DATA_MISSING",
  IN_PROCESS = "IN_PROCESS",
}
export {
  EnumUtils,
  PolicyType,
  BasicProcessPhase,
  ActionRequestStateType,
  UiActionStatus,
  ConditionStatus,
  SignAlgorithm,
};
